import { APICfg } from 'services/api/api'
import { ProductPreset, ProductPackage } from './common'

export type DrinkVariantPreset = ProductPreset & {
  drinksPerPerson: number
}

export type APIDrinkPreset = ProductPreset & {
  variants: DrinkVariantPreset[]
}

export type DrinkPreset = APIDrinkPreset

export type APIDrinkPackage = ProductPackage<APIDrinkPreset>

export type DrinkPackage = APIDrinkPackage

const apiCfg: APICfg = {
  endpoint: 'drinkPackage',
  parse: (req: APIDrinkPackage): DrinkPackage => req,
  write: async (req: DrinkPackage): Promise<APIDrinkPackage> => req,
}

export default apiCfg
